export default "__VITE_ASSET__fQnlOMob__"